import { stringHelpers } from '@approvalmax/utils';
import { constants } from 'modules/common';
import { z } from 'zod';

import { noteFieldName } from './NoteForApproversSection.constants';
import { messages } from './NoteForApproversSection.messages';

export const createSchema = (required: boolean) => {
    return z.object({
        [noteFieldName]: z
            .string()
            .trim()
            .refine(
                (value) => {
                    const cleanRequestNote =
                        stringHelpers.cleanHTMLAttributes(
                            constants.commonConstants.REQUEST_NOTE_EXCLUDED_ATTRIBUTES,
                            value
                        )?.length || 0;

                    return cleanRequestNote <= constants.commonConstants.REQUEST_NOTE_MAX_LENGTH;
                },
                {
                    message: messages.maxLength({
                        maxLength: String(constants.commonConstants.REQUEST_NOTE_MAX_LENGTH),
                    }),
                }
            )
            .refine((value) => !required || value, {
                message: messages.required,
            }),
    });
};
